(() => {
  if (window.RubyAutoSets) { window.RubyAutoSets(); return; }
  const normal = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const kinds = [
    ['speenkoord', /speenkoord/], ['speendoek', /speendoek|accessoire.*speen/],
    ['bijtring', /bijtring/], ['doek', /mousseline.*doek|multifunctionele.*doek|hydrofiel/],
    ['slofjes', /slof/], ['romper', /romper/], ['deken', /deken/], ['babyhaarband', /babyhaarband/],
    ['babymuts', /babymuts/], ['handschoenen', /handschoen|wantjes/], ['sjaal', /sjaal/],
    ['muts', /muts/], ['broodtrommel', /broodtrommel(?!kaart)/], ['kaartjes', /broodtrommelkaart/],
    ['fles', /drinkfles|thermosfles|waterfles/], ['rugzak', /rugzak/], ['gymtas', /zwemtas|gymtas/],
    ['pet', /kinderpet|petje/], ['sleutelhanger', /sleutelhanger/], ['toilettas', /toilettas/],
    ['slabber', /slabber/], ['placemat', /placemat/], ['servies', /servies|bordje|kommetje/],
    ['bestek', /bestek|lepel|vork/], ['badpak', /badpak/], ['zwembroek', /zwembroek/]
  ];
  const groups = [
    ['speenkoord', 'speendoek', 'bijtring', 'doek'],
    ['babymuts', 'romper', 'deken', 'slofjes', 'babyhaarband'],
    ['muts', 'sjaal', 'handschoenen'],
    ['broodtrommel', 'fles', 'rugzak', 'gymtas', 'kaartjes', 'pet', 'sleutelhanger', 'toilettas'],
    ['slabber', 'placemat', 'servies', 'bestek', 'fles', 'broodtrommel'],
    ['badpak', 'zwembroek', 'pet', 'gymtas']
  ];
  const designs = ['teckel', 'croissant', 'smiley', 'bloem', 'hart', 'beer', 'strik', 'panter'];
  const colors = ['donker bruin', 'licht bruin', 'licht roze', 'ice blauw', 'licht blauw', 'mint groen', 'licht groen', 'licht geel', 'neon geel', 'caramel', 'beige', 'creme', 'bruin', 'roze', 'oranje', 'lilla', 'lila', 'paars', 'blauw', 'groen', 'geel', 'rood', 'wit', 'zwart', 'grijs', 'peach', 'pink'];
  const primary = ['teckel', 'croissant', 'smiley', 'bloem', 'hart', 'beer', 'strik'];
  function details(product) {
    const text = normal(product.title);
    const tags = normal(Array.isArray(product.tags) ? product.tags.join(' ') : product.tags);
    const kind = kinds.find(([, pattern]) => pattern.test(text))?.[0] || kinds.find(([, pattern]) => pattern.test(normal(product.type)))?.[0] || '';
    const design = primary.find(word => text.includes(word)) || primary.find(word => tags.includes(word)) || (text.includes('panter') ? 'panter' : '');
    const color = colors.find(word => (' ' + text + ' ').includes(' ' + word + ' ')) || '';
    return {kind, design, color: color.replace('lilla', 'lila').replace('pink','roze'), text};
  }
  function score(source, item) {
    const target = details(item);
    if (!source.kind || !target.kind || source.kind === target.kind) return -1;
    if (!groups.some(group => group.includes(source.kind) && group.includes(target.kind))) return -1;
    if (source.design && source.design !== target.design) return -1;
    const strictColor = ['babymuts','romper','deken','slofjes','babyhaarband','muts','sjaal','handschoenen'].includes(source.kind);
    if (!source.design && (!source.color || source.color !== target.color)) return -1;
    if (strictColor && source.color && target.color && source.color !== target.color) return -1;
    return 20 + (source.design && source.design === target.design ? 50 : 0) + (source.color && source.color === target.color ? 30 : 0);
  }
  const requests = new Map();
  async function html(url) {
    const key = url.href;
    if (!requests.has(key)) requests.set(key, fetch(url, {credentials:'same-origin', signal: AbortSignal.timeout(15000)})
      .then(response => {if (!response.ok) throw new Error('Set request failed'); return response.text();})
      .catch(error => {requests.delete(key); throw error;}));
    return requests.get(key);
  }
  function urlFor(path) {
    const url = new URL(path, location.origin);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    url.searchParams.set('section_id', 'ruby-set-candidates');
    return url;
  }
  async function update(section) {
    if (section.dataset.autoStarted) return;
    section.dataset.autoStarted = 'true';
    const source = details({title:section.dataset.title, tags:section.dataset.tags});
    if (!source.kind) {section.dataset.autoState='unclassified'; return;}
    const query = source.design || source.color;
    if (!query) {section.dataset.autoState='unclassified'; return;}
    const items = new Map();
    try {
      let pages = 1;
      for (let page = 1; page <= pages; page++) {
        const url = urlFor(section.dataset.search);
        url.searchParams.set('q', query);
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[prefix]', 'last');
        url.searchParams.set('page', String(page));
        const doc = new DOMParser().parseFromString(await html(url), 'text/html');
        const index = doc.querySelector('[data-ruby-set-index]');
        if (!index) throw new Error('Set index unavailable');
        const data = JSON.parse(index.textContent);
        pages = Number(data.pages) || 1;
        for (const item of data.items) {
          if (String(item.id) !== section.dataset.productId && !normal(item.title).includes('b2b') && !(item.tags || []).includes('B2B-OLD')) items.set(item.id, item);
        }
      }
      const ranked = [...items.values()].map(item => ({item, score:score(source,item)})).filter(row=>row.score>=0).sort((a,b)=>b.score-a.score || a.item.handle.localeCompare(b.item.handle));
      const chosen = [];
      const selectedKinds = new Set();
      for (const row of ranked) {
        const kind = details(row.item).kind;
        if (selectedKinds.has(kind)) continue;
        chosen.push(row.item); selectedKinds.add(kind);
        if (chosen.length === 3) break;
      }
      const root = section.dataset.root.replace(/\/$/, '');
      const cards = await Promise.all(chosen.map(async item => {
        const doc = new DOMParser().parseFromString(await html(urlFor(root + '/products/' + item.handle)), 'text/html');
        return doc.querySelector('[data-ruby-set-product]');
      }));
      const availableCards = cards.filter(Boolean);
      if (availableCards.length) {
        section.querySelector('ul').replaceChildren(...availableCards);
        section.hidden = false;
      }
      section.dataset.autoState = availableCards.length ? 'ready' : 'no-match';
      section.dataset.autoCandidates = String(items.size);
    } catch (error) { section.dataset.autoState = 'fallback'; }
  }
  function init() {
    document.querySelectorAll('[data-ruby-auto-sets]').forEach(section => {
      if (section.dataset.autoObserved) return;
      section.dataset.autoObserved='true';
      if ('IntersectionObserver' in window) {
        const observer=new IntersectionObserver(entries => {
          if (entries.some(entry=>entry.isIntersecting)) {observer.disconnect(); update(section);}
        }, {rootMargin:'1200px'});
        if (section.hidden) update(section); else observer.observe(section);
      } else update(section);
    });
  }
  window.RubyAutoSets = init;
  document.addEventListener('shopify:section:load', init);
  init();
})();
